<template>
  <van-popup class="pop-box " v-model="show" round position="bottom">
    <div class="container">
      <div class="title">
        {{$t('lang.t218')}}
      </div>
      <div class="contacts">
        <commonContactItem :isShowProduct='true' :language="language" v-for="(item, index) in arr" :key="index" :customClass="['pt-10 px-10 pb-20 ', index == 0 ? '' : 'mt-10']" :item='item'></commonContactItem>
      </div>
      <div class="title">
        {{$t('lang.t219')}}
      </div>
      <div class="form">
        <!-- 姓名 -->
        <div class="form-item">
          <div class="left" style="width: 100rpx;">
            <span style="color: #f52f3e">*</span>
            {{$t('lang.t220')}}:
          </div>
          <div class="right">
            <input class="" v-model="userName" type="text" disabled :placeholder="$t('lang.t228')">
          </div>
        </div>
        <!-- 机构 -->
        <div class="form-item">
          <div class="left" style="width: 100rpx;">
            <span style="color: #f52f3e">*</span>
            {{$t('lang.t221')}}:
          </div>
          <div class="right">
            <input class="" v-model="userInfo.companyName" type="text" :placeholder="$t('lang.t229')">
          </div>
        </div>
        <!-- 职位 -->
        <div class="form-item">
          <div class="left" style="width: 100rpx;">
            {{$t('lang.t222')}}:
          </div>
          <div class="right">
            <input v-model="userInfo.position" class="" type="text" :placeholder="$t('lang.t230')">
          </div>
        </div>
        <!-- 电话 -->
        <div class="form-item">
          <div class="left" style="width: 100rpx;">
            <span style="color: #f52f3e">*</span>
            {{$t('lang.t223')}}:
          </div>
          <div class="right">
            <input :disabled='phoneDisabled' v-model="userInfo.phone" class="" type="text" :placeholder="$t('lang.t231')">
          </div>
        </div>
        <!-- 邮箱 -->
        <div class="form-item">
          <div class="left" style="width: 100rpx;">
            <span style="color: #f52f3e">*</span>
            {{$t('lang.t224')}}:
          </div>
          <div class="right">
            <input :disabled='emailDisabled' v-model="userInfo.email" class="" type="text" :placeholder="$t('lang.t232')">
          </div>
        </div>
        <!-- 地区 -->
        <div class="form-item">
          <div class="left" style="width: 100rpx;">
            {{$t('lang.t225')}}:
          </div>
          <div class="right" @click="showPhoneAreaFunc('area')">
            <div class="placeHolder" v-if="userInfo.country == ''">{{$t('lang.t233')}}</div>
            <div class="word" v-else>{{userInfo.country}}</div>
          </div>
        </div>

        <div class="form-item" v-if="userInfo.countryCode == '+86'">
          <div class="left" style="width: 100rpx;">
            {{$t('lang.t226')}}:
          </div>
          <div class="right" @click="showArea = true">
            <div class="placeHolder" v-if="form.location == ''">{{$t('lang.t234')}}</div>
            <div class="word" v-else>{{form.location}}</div>
          </div>
        </div>

        <!-- 地址 -->
        <div class="form-item">
          <div class="left" style="width: 100rpx;">
            {{$t('lang.t227')}}:
          </div>
          <div class="right">
            <input v-model="userInfo.fullAddress" type="text" :placeholder="$t('lang.t235')">
          </div>
        </div>
        <!-- 意向 -->
        <div class="form-item">
          <div class="left">
            {{$t('lang.t236')}}:
          </div>
          <div class="right">
            <van-radio-group class="group" v-model="radio" icon-size="18px" @change="handleChange">
              <van-radio class="group-item" name="采购产品" checked-color="#00C4C9"> {{$t('lang.t237')}}</van-radio>
              <van-radio class="group-item" name="代理产品" checked-color="#00C4C9">{{$t('lang.t238')}}</van-radio>
              <van-radio class="group-item" name="市场合作" checked-color="#00C4C9">{{$t('lang.t239')}}</van-radio>
              <van-radio class="group-item" name="其他" checked-color="#00C4C9">{{$t('lang.t240')}}</van-radio>
            </van-radio-group>

            <van-field v-model="otherMessage" rows="2" autosize type="textarea" maxlength="100" :placeholder="$t('lang.t247')" show-word-limit style="padding:0;" />
          </div>
        </div>


        <div class="placeholder"></div>
        <div class="bottomBtn">
          <div class="btn" :class="isClickSubmit ? 'vivify duration-150 pulsate' : ''" @click="handleSummit">{{$t('lang.t78')}}</div>
        </div>
      </div>
    </div>

    <van-popup v-model="areaPicker" round position="bottom">
      <van-picker show-toolbar :columns="areaColumns" @cancel="areaPicker = false" @confirm="confirmChooseArea" />
    </van-popup>

    <van-popup v-model="showArea" round position="bottom">
      <van-cascader v-model="form.location" :title="$t('lang.t57')" :field-names="fieldNames" :options="options" @close="showArea = false" @change="onChange" @finish="onFinish" />
    </van-popup>

  </van-popup>
</template>
<script>
import commonContactItem from './commonContactItem.vue'
import { getCountryCode, getProvince, getCity, getAreaByCity, enterpriseAddClue } from '@/api/interNational'
export default {
  name: 'vistorLinkUsPop',
  props: {
    language: {
      type: String,
      default: '',
    },
    enterpriseCode: {
      type: String,
      default: '',
    },
    company: {
      type: String,
      default: '',
    },
    channel: {
      type: String,
      default: 'BUSINESS_CONSULTATION',
    },
    source: {
      type: String,
      default: '',
    },
    meetingCode: {
      type: String,
      default: '',
    },
    shareParams: {
      type: Object,
      default: {},
    }
  },
  components: { commonContactItem },
  data() {
    return {
      show: false,
      arr: [],
      isClickSubmit: false,
      radio: '采购产品',
      userInfo: {
        name: '',
        companyName: '',
        position: '',
        email: '',
        country: '',
        address: '',
      },
      areaPicker: false,
      areaColumns: [],
      countryIndex: '',
      showArea: false,
      form: {
        location: '',
      },
      fieldNames: {
        text: 'name',
        value: 'code',
        children: 'children',
      },
      options: [],
      phoneDisabled: false,
      emailDisabled: false,
      otherMessage: '',
      chooseList: [
        {
          value: 0,
          name: '采购产品',
        },
        {
          value: 1,
          name: '代理产品',
        },
        {
          value: 2,
          name: '市场合作',
        },
        {
          value: 3,
          name: '其他',
        },
      ],
    }
  },
  computed: {
    userName() {
      let firstNameFlag = ['+86', '+852', '+853', '+886', '+36', '+82', '+81', '+84']
      if (this.userInfo.name) {
        return this.userInfo.name
      }

      if (!!this.userInfo.countryCode || (this.userInfo.firstName && firstNameFlag.indexOf(this.userInfo.countryCode) >= 0)) {
        return this.userInfo.firstName + ' ' + this.userInfo.lastName
      }

      if (this.userInfo.countryCode == '' || (this.userInfo.firstName && firstNameFlag.indexOf(this.userInfo.countryCode) >= 0)) {
        return this.userInfo.firstName + ' ' + this.userInfo.lastName
      }
      if (this.userInfo.firstName && firstNameFlag.indexOf(this.locaelLanguage) < 0) {
        return this.userInfo.lastName + ' ' + this.userInfo.firstName
      }
    },
    locaelLanguage() {
      return this.$i18n.locale
    },
  },

  methods: {
    pageScrollTop() {
      const app = document.querySelector('.container')
      console.log('执行')
      app.scrollIntoView()
    },
    showPhoneAreaFunc(type) {
      this.getPhoneCode()
      if (type == 'phoneCountry') {
        this.areaCodePicker = true
      } else {
        this.areaPicker = true
      }
    },
    async getPhoneCode() {
      const { data } = await getCountryCode({}, { language: this.locaelLanguage })
      this.allAreaCode = data
      this.$set(this.areaColumns, 0, this.handlePickerAreaCode(data).countryArr)
    },
    confirmChooseArea(e, index) {
      this.userInfo.country = this.allAreaCode[index].country
      this.userInfo.countryCode = this.allAreaCode[index].countryCode
      this.countryIndex = index
      this.areaPicker = false
    },
    handlePickerAreaCode(arr) {
      let pickerValueArr = {
        values: [],
        defaultIndex: 0,
      }
      let countryArr = {
        values: [],
        defaultIndex: 0,
      }
      arr.forEach((v) => {
        let value = v.country + v.countryPhoneCode
        pickerValueArr.values.push(value)
        countryArr.values.push(v.country)
      })
      return { pickerValueArr, countryArr }
    },
    async getProvinceFunc() {
      const { data } = await getProvince()
      console.log(data)
      data.forEach((v) => {
        v.children = []
      })
      this.options = data
      console.log(this.options)
    },
    // 省市区选择
    onChange(e) {
      console.log(e)
      let { value, tabIndex, selectedOptions } = e
      if (tabIndex == 0) {
        this.getCityFunc(value, tabIndex, selectedOptions)
      }
      if (tabIndex == 1) {
        this.getAreaFunc(value, tabIndex, selectedOptions)
      }
    },

    getCityFunc(code, index, selectedOptions) {
      getCity({}, { code }).then((res) => {
        selectedOptions[0].children = this.handleData(res.data, false)
      })
    },
    handleData(data, notChild) {
      data.forEach((v) => {
        if (!notChild) {
          v.children = []
        }
        v.value = v.code
        v.text = v.name
      })
      return data
    },

    getAreaFunc(code, index, selectedOptions) {
      getAreaByCity({}, { code }).then((res) => {
        selectedOptions[selectedOptions.length - 1].children = this.handleData(res.data, true)
      })
    },
    onFinish({ selectedOptions }) {
      this.showArea = false
      console.log(selectedOptions)
      this.form.location = selectedOptions.map((option) => option.name).join(' ')
      this.form.province = selectedOptions[0].name
      this.form.provinceCode = selectedOptions[0].code
      this.form.city = selectedOptions[1].name
      this.form.cityCode = selectedOptions[1].code
      this.form.area = selectedOptions[2].name
      this.form.areaCode = selectedOptions[2].code
    },
    initLocation(userInfo) {
      this.form.location = userInfo.province + userInfo.city + userInfo.area
      this.form.province = userInfo.province
      this.form.provinceCode = userInfo.provinceCode
      this.form.city = userInfo.city
      this.form.cityCode = userInfo.cityCode
      this.form.area = userInfo.area
      this.form.areaCode = userInfo.areaCode
    },

    // 打开
    close() {
      this.show = false
    },
    open(list) {
      this.arr = list
      this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : { name: '', companyName: '', position: '', email: '', country: '', address: '' }
      if (!!this.userInfo.phone) {
        this.phoneDisabled = true
      }
      if (!!this.userInfo.email) {
        this.emailDisabled = true
      }
      this.getProvinceFunc()
      this.initLocation(this.userInfo)
      this.show = true
    },
    handleChooseArea() {
      console.log('选择地区')
    },
    handleChange(e) {
      console.log('意向选择eeee', e)
    },
    handleSummit() {
      console.log('提交')
      if (this.isClickSubmit) return false
      let e = this.userInfo
      let params = {
        address: e.fullAddress,
        area: `${e.country}${this.form.location}`,
        channel: this.channel,
        company: e.companyName,
        email: e.email,
        enterpriseCode: this.enterpriseCode,
        language: this.language,
        name: this.userName,
        phone: e.phone,
        position: e.position,
        sourceType: 'H5_SOURCE',
        content: this.radio,
        source: this.source,
        meetingCode: this.meetingCode,
        message: this.otherMessage,
        relationCode: this.meetingCode
      }

      if (this.shareParams.hasOwnProperty('shareUserType')) {
        params.sourceRelationCode = this.shareParams.shareUserType == 'USER' ? this.shareParams.shareUid : this.shareParams.shareEnCode 
        params.sonChannel = this.shareParams.shareUserType == 'USER' ? 'ENTERPRISE_HOMEPAGE_USER_DRAINAGE' : 'ENTERPRISE_HOMEPAGE_ENTERPRISE_DRAINAGE'
      }

      if (this.$isEmpty(params.phone)) {
        this.$toast(this.$t('lang.t53'))
        return false
      }
      if (this.$isEmpty(params.email)) {
        this.$toast(this.$t('lang.t51'))
        return false
      }
      console.log(params)
      this.isClickSubmit = true
      enterpriseAddClue({}, params)
        .then((res) => {
          this.close()
          this.$toast(`${this.company} ${this.$t('lang.t313')}`)
          setTimeout(() => {
            this.isClickSubmit = false
          }, 200)
        })
        .catch((err) => {
          this.$toast(`留资失败`)
          setTimeout(() => {
            this.isClickSubmit = false
          }, 200)
        })
    },
  },
  mounted() {},
}
</script>
<style scoped>
input {
  border: 0;
  outline: 0;
  background-color: #fff;
  height: 23px;
}

input::placeholder {
  color: #bfbfbf;
}

input::-webkit-input-placeholder {
  color: #bfbfbf;
}

input::-moz-input-placeholder {
  color: #bfbfbf;
}

input::-ms-input-placeholder {
  color: #bfbfbf;
}

.pop-box {
  max-height: 70vh;
  padding-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;
  height: 53px;
  padding: 0 12px;
  box-sizing: border-box;
  width: 100%;
  color: #262626;
  font-weight: 700;
  font-size: 16px;
}

.contacts {
  overflow: auto;
  max-height: 300px;
  padding: 0 12px;
  box-sizing: border-box;
}

.form {
  padding: 0 12px;
}

.form-item {
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  min-height: 40px;
}

.left {
  display: flex;
  color: #262626;
  margin-right: 6px;
  font-size: 14px;
  padding-bottom: 5px;
  min-width: 50px;
  max-width: 110px;
}

.left span {
  color: #f52f3e;
}

.right {
  flex: 1;
  padding-bottom: 5px;
  border-bottom: 1px solid #e0e0e0;
}

.right input {
  flex: 1;
  color: #262626 !important;
  font-size: 14px;
}
.right .group {
  display: flex;
  flex-wrap: wrap;
}
.right .group .group-item {
  padding: 5px 10px 5px 0;
}
.placeholder {
  height: 80px;
}

.bottomBtn {
  position: fixed;
  z-index: 10;
  left: 0;
  right: 0;
  bottom: 0;
  height: 80px;
  padding: 10px 18px 0;
  box-sizing: border-box;
  background-color: #fff;
}

.bottomBtn .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
  background-color: #00c4c9;
  height: 44px;
}
</style>